import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {Badge, Button, Card, CardContent, CardHeader, Grid, IconButton, Stack} from "@mui/material";
import FormFieldText from "../../../../../../components/FormFieldText";
import {UserDto} from "../../../../../../modules/account/dto/UserDto";

export type VisitRequestProps = {
    applicant: UserDto;
};

const VisitRequest: React.FC<VisitRequestProps> = (props) => {
    const intl = useIntl();

    return (
        <Card>
            <CardHeader title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_APPLICANT_INFO'})}/>
            <CardContent>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_APPLICANT_STAFF_NUMBER"})}
                                       disabled={true}
                                       value={props.applicant.uid}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_APPLICANT_NAME"})}
                                       disabled={true}
                                       value={props.applicant.fullName}/>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default VisitRequest;